import Vue from 'vue'
import Vuex from 'vuex'
import f from '@/application/functions'


Vue.use(Vuex)

export default new Vuex.Store({

  state : {
      icon : null,
      cache : {},
      wssready : false,
      auth : undefined,
      inviteCode: null,
  },
  
  mutations: {

    auth : function(state){

      return new Promise((resolve, reject) => {

        f.retry(function(){
          return typeof state.auth != 'undefined'
        }, function(){

          resolve(state.auth)

        })

      }) 

      
    },

    init(state){


    },

    icon(state, value){

      state.icon = value

    },

    inviteCode(state, value) {
      state.inviteCode = value;
    },

    wssready(state, value){

      state.wssready = value

    },

    userinfo_change : function(){},

    /////////


    createCache : function(state, key){
      state.cache[key] = {}
    },

    addToCache: function(state, key, id, value){

      if(!state.cache[key]) this.createCache(state, key)

      state.cache[key][id] = value

    },
  }
})
